import styled from 'styled-components';
import messages from '../test/data/message.json';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom'
import { Color } from '../common/theme'
import * as HomeConfig from '../test/data/home.configs'

const MsgList = styled.div`
  --bs-gutter-x: 0rem;
  .list-header{
    background-color: ${Color.Primary};
    padding: 0.3rem 0;
    img{
      width:1rem;
      height:1rem;
      margin-top:1px;
      margin-left:0px;
      float:left;
    }
    a{
      padding-left:3px;
      display:block;
      float:left;
      font-weight: bold;
      color: #fff;
    }
  }
  .list-item{
    img{
      width: 1rem;
      height: 1rem;
    }
    .text{
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
    a{
      color: ${Color.FontColor}
    }
  }


  @media screen and (max-width:290px){
    font-size:0.5rem;
  }
`

export default function HomeContent(){
    return <>
        <div key={uuidv4()} className="col p-0 m-0">
          <div key={uuidv4()} className="row d-flex justify-content-center p-2 m-1">
            <div key={uuidv4()} className="col align-middle text-center">嗨！张三您好！智慧校园欢迎您的到来!</div>
          </div>
          {
          HomeConfig.MessageItems.map((v:any) =>
            <MsgList key={uuidv4()} className="row m-0 p-0 mb-3 mx-2  d-flex justify-content-center">
            <div key={uuidv4()} className="row list-header mb-2 mx-0 px-0 d-flex align-items-center rounded-pill">
                <div key={uuidv4()} className="col-1"><img src={v.icon} alt={v.title} /></div>
                <div key={uuidv4()} className="col"><Link to={v.url}>{v.title}</Link></div>                
            </div>
            {
              messages.map(v => {
                return <div key={uuidv4()} className="row list-item mx-0 px-0 d-flex align-items-center">
                  <div className="col-1 d-flex" key={uuidv4()}><img src={'/assets/icon/message.svg'} alt={v.title} /></div>
                  <div className="col text" key={uuidv4()}><Link to={`/new/${uuidv4()}`}>{v.title}</Link></div>
                </div>
              })
            }
            </MsgList>)
          }
        </div>
    </>
}